import React from "react";
import ReactDOM from "react-dom";
import "./styles/global.scss";
import App from "./App";
import WlpApp from "@components/WLP202603/App";
import "react-image-lightbox/style.css";
import { initStore } from "./store";
import moment from "moment";
import { IRackItem } from "@components/Pages/Locations/LocationRow/LocationMore/RackTable/Rack/RackItem/RackItem.props";
import { IWorkEquipment } from "@store/Equipments/actionTypes";
import { TypePartialRackItem } from "@components/Pages/Locations/LocationRow/LocationMore/RackTable/Rack/Rack.props";
import dayjs from "dayjs";
import { setupChunkErrorHandler } from "@utils/chunkErrorHandler";
import ChunkErrorBoundary from "@components/ErrorBoundary/ChunkErrorBoundary";
import { WLP202603 } from "./config";

var timezone = require("dayjs/plugin/timezone");
timezone = "Europe/Moscow";

// устаналиваем дефолтную зону для всего проекта
moment.tz?.setDefault("Europe/Moscow");

declare global {
  interface Window {
    SERVER_TIME_DELTA: number;
    DRAGING_OVER_RACK?: boolean; // - если перетаскиваемый темплейт шкафа находится непосредственно над шкафом
    DRAGING_FOR_MERGE?: {
      index: number;
      rackId: string;
      rackItem: IRackItem;
    };
    TRANSFER_RACK_ITEM?: {
      merge?: string[];
      size?: number[];
      arrayItem?: TypePartialRackItem[];
      prevIndex: number;
      draggingItem: IRackItem;
      prevRackItems: TypePartialRackItem[];
    };
    WORK_EQUIPMENT?: IWorkEquipment;
    REORDER_UNRACK_ITEM?: {
      id: number;
    };
  }
}

// Настройка обработчика ошибок загрузки чанков
setupChunkErrorHandler();

ReactDOM.render(
  <React.StrictMode>
    <ChunkErrorBoundary>
      {initStore(WLP202603 === true ? WlpApp : App)}
    </ChunkErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);
